var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "URL", "prepend-inner-icon": "mdi-link" },
                model: {
                  value: _vm.url,
                  callback: function ($$v) {
                    _vm.url = $$v
                  },
                  expression: "url",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Usuario",
                  "prepend-inner-icon": "mdi-account",
                },
                model: {
                  value: _vm.username,
                  callback: function ($$v) {
                    _vm.username = $$v
                  },
                  expression: "username",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Contraseña",
                  "prepend-inner-icon": "mdi-lock",
                  type: _vm.showPassword ? "text" : "password",
                  "append-icon": _vm.showPassword ? "mdi-eye-off" : "mdi-eye",
                  "append-outer-icon": "mdi-content-copy",
                },
                on: {
                  "click:append": _vm.togglePassword,
                  "click:append-outer": _vm.copyPassword,
                },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v
                  },
                  expression: "password",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }